import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; // Your Firebase configuration
import { Box, Typography, IconButton, Button, CircularProgress, Avatar, Card, CardHeader, CardContent, CardMedia } from "@mui/material";
import { Favorite, Share, ChevronLeft, ChevronRight, MoreVert } from "@mui/icons-material";

const PostCarousel = ({ post }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? post.postPics.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === post.postPics.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxHeight: "600px",
        margin: "0 auto",
        overflow: "hidden",
        boxShadow: 1,
        borderRadius:3,
        boxShadow: 0,
      }}
    >
      {/* Display Current Image */}
      <img
        src={post.postPics[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* Left Arrow */}
      <IconButton
        onClick={handlePrev}
        sx={{
          position: "absolute",
          top: "50%",
          left: "10px",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
        }}
      >
        <ChevronLeft />
      </IconButton>

      {/* Right Arrow */}
      <IconButton
        onClick={handleNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
        }}
      >
        <ChevronRight />
      </IconButton>

      {/* Dots Indicator */}
      <Box
        sx={{
          position: "absolute",
          bottom: "10px",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "5px",
        }}
      >
        {post.postPics.map((_, index) => (
          <Button
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: currentIndex === index ? "white" : "rgba(255, 255, 255, 0.5)",
              minWidth: 0,
              padding: 0,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

const EventPostCarousel = ({ eventDocId }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        setError("");

        const postsRef = collection(db, `events/${eventDocId}/posts`);
        const querySnapshot = await getDocs(postsRef);

        if (querySnapshot.empty) {
          setPosts([]);
        } else {
          const fetchedPosts = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setPosts(fetchedPosts);
        }
      } catch (err) {
        console.error("Error fetching posts:", err);
        setError("Failed to load posts. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [eventDocId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", marginTop: 4 }}>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (posts.length === 0) {
    return (
      <Box sx={{ textAlign: "center", marginTop: 4 }}>
        <Typography variant="h6">No posts available for this event.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 1, marginTop: 3,
              bgcolor: 'background.paper', 
              borderRadius:3,}}>
      {posts.map((post) => (
        <Box 
        // sx={{ borderBottom: '1px solid #efefef',}}
        >
          
          {/* card media */}
          <Card key={post.id}  sx={{ marginBottom: 2, boxShadow: 0, }}>
                  <CardHeader
                    avatar={<Avatar src={post.postImage} alt={post.postAuthorID} />}
                    // action={
                    //   <IconButton aria-label="settings">
                    //     <MoreVert />
                    //   </IconButton>
                    // }
                    title={post.postAuthorID} 
                    subheader={new Date(post.timestamp.seconds * 1000).toLocaleString()}
                  />
                  
                    <CardMedia>
                       <PostCarousel post={post} />
                    </CardMedia>
                                      
                   <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 16px' }}>
                    <IconButton aria-label="add to favorites">
                      <Favorite /> 
                      <Typography variant="body2" color="textSecondary">
                        12k
                      </Typography>
                    </IconButton>
                    {/* <IconButton aria-label="share">
                      <Share />
                    </IconButton> */}
                  </div>

                  <CardContent style={{  paddingTop: '0' }}>
                    <Typography variant="body2" color="textSecondary">
                      {post.postText}
                    </Typography>
                  </CardContent>
                  
                </Card>
        {/* end of card media */}
      
        </Box>
      ))}
    </Box>
  );
};

export default EventPostCarousel;
